import moment from "moment";
import React, { ReactElement, useMemo } from "react";
import { OperationalTargetProps } from "./OperationalTarget.types";
import { CaptionBolder, CaptionBody } from "../Text";
import { localize } from "src/l10n";
import { Conditional } from "../Conditional";

/**
 * OperationalTarget component
 *
 * @param {OperationalTargetProps} props - The component props
 * @returns {ReactElement | null} The rendered component
 */
function OperationalTarget({
    target,
}: OperationalTargetProps): ReactElement | null {
    const now = new Date();

    const l10n = useMemo(() => ({
        target: localize("OPS_TARGET_TARGET_TEXT"),
        focus: localize("OPS_TARGET_FOCUS"),
    }), []);

    return (
        <div className="OperationalTarget">
            <Conditional condition={target.target.length > 0}>
            <div className="OperationalTarget-target">
                <CaptionBolder color="contentDark">
                    {l10n.target.replace('{0}', moment(now).format("MMMM D"))}:
                </CaptionBolder>
                <CaptionBolder color="pink">
                    {target.target}.
                </CaptionBolder>
            </div>
            </Conditional>
            <Conditional condition={target.focus.length > 0}>
                <div className="OperationalTarget-focus">
                    <CaptionBolder color="contentDark">
                        {l10n.focus}:
                    </CaptionBolder>
                    <CaptionBody color="contentNormal">
                        {target.focus}
                    </CaptionBody>
                </div>
            </Conditional>
        </div>
    );
}

export default OperationalTarget;

